import enUS from './en.js';
import urPK from './ur.js';
import arSA from './arabic.js';

const translations = { 'en-US': enUS, 'ur-PK': urPK, 'ar-SA': arSA };

let currentLanguage = localStorage.getItem('lang') || 'en-US';

document.body.dir = currentLanguage === 'en-US' ? 'ltr' : 'rtl';

export const setLanguage = (lang) => {
  if (translations[lang]) {
    currentLanguage = lang;
    localStorage.setItem('lang', lang);
    localStorage.setItem('isReloadingForLang', 'true');
    window.location.reload();
  }
};


export const t = (key) => {
  const keys = key.split('.');
  return keys.reduce((obj, k) => (obj && obj[k]) ? obj[k] : key, translations[currentLanguage]);
};


export const getCurrentLanguage = () => currentLanguage;
